import React, { useEffect } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { updateTermsAndConditions } from 'api/cart/cartTermsAndConditions'

interface Props {
  cartId: string
}

function TermsAndConditionsAcknowledgedModal({ cartId }: Props) {
  useEffect(() => {
    updateTermsAndConditions(cartId, {
      accepted: true,
      acceptedAt: new Date().toISOString(),
    })
  }, [cartId])

  return (
    <ModalBase>
      <ModalHeader title="Thank you for reviewing the terms and conditions" />
      <ModalBody>
        <ModalContent>
          <BodyText variant="medium">
            Your acknowledgement has been recorded.
          </BodyText>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Close',
        }}
      />
    </ModalBase>
  )
}

export default TermsAndConditionsAcknowledgedModal
